export default __webpack_public_path__ + "static/pyramids-fe52b768ad617f95522a6ec1fd0cd51f.jpg";